// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

// Soft UI Dashboard PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { dark, light } = colors;
const { size, fontWeightBold } = typography;

const formControlLabel = {
  styleOverrides: {
    root: {
      display: "block",
      minHeight: pxToRem(24),
      marginBottom: pxToRem(2),
    },

    label: ({ theme }) => ({
      display: "inline-block",
      fontSize: size.sm,
      fontWeight: fontWeightBold,
      color: theme.palette.mode === "dark" ? light.main : dark.main,
      lineHeight: 1,
      transform: `translateY(${pxToRem(1)})`,
      marginLeft: pxToRem(4),

      "&.Mui-disabled": {
        color: theme.palette.mode === "dark" ? light.main : dark.main,
      },
    }),
  },
};

export default formControlLabel;
